import * as React from "react";
import { forwardRef } from "react";
const SvgCloseX = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 40, height: 40, viewBox: "0 0 40 40", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M10.7158 29.2822L29.2774 10.7207", stroke: "#151519", strokeWidth: 2.5, strokeMiterlimit: 10, strokeLinecap: "square" }), /* @__PURE__ */ React.createElement("path", { d: "M29.2773 29.2822L10.7158 10.7207", stroke: "#151519", strokeWidth: 2.5, strokeMiterlimit: 10, strokeLinecap: "square" }));
const ForwardRef = forwardRef(SvgCloseX);
export default ForwardRef;
